export default class SubscriberFormCtrl {
    constructor(SideMenu, SubscriberForm, $state, SweetAlert, $filter) {
        SideMenu.setActive("subscriber");

        this._state = $state;
        this._translator = $filter('translate');

        this.subscriberFormRepo = SubscriberForm;
        this.alerter = SweetAlert;

        this.subscriberFormRepo.all().then((subscriberForms) => {
            this.subscriberForms = subscriberForms.data;
            this.loadedTags = [];
        });
    }

    goTo(subscriberForm, page) {
        if (page === 'email') {
            if (subscriberForm.email) {
                this._state.go('subscriberForm.email.edit', { id: subscriberForm.id, emailId: subscriberForm.email.data.id });
            } else {
                this._state.go('subscriberForm.email', { id: subscriberForm.id });
            }
        } else {
            this._state.go('subscriberForm.' + page, { id: subscriberForm.id });
        }
    };

    goToBuilder() {
        this._state.go('subscriberForm.builder');
    }

    deleteSubscriberForm(subscriberForm, index) {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:DELETE'),
            text: this._translator('SUBSCRIBER_FORM_MODAL:DELETE:DELETE'),
            type: "warning",
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            if (isConfirm) {
                this.subscriberFormRepo.delete(subscriberForm).then(() => {
                    this.subscriberForms.splice(index, 1);
                });
            }
        })
    };
};